


























































































































































































































































import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import { TranslateResult } from 'vue-i18n';
import MathJaxMixin from '../../../mixins/mathJax.mixin';
import { Blank } from '../../../types/questions.type';
import Utils from '../../../shared/utils/index';

@Component({})
export default class ViewBlanksColumns extends mixins(MathJaxMixin) {
  @Prop(Array) readonly blanks!: Blank[];

  @Prop(String) readonly questionText!: string;

  @Prop(String) readonly questionDirection!: string;

  @Prop(Number) readonly SpecIndex!: number;

  @Prop(Number) readonly questionIndex!: number;

  @Prop(Boolean) readonly simulation!: boolean;

  @Prop(Boolean) readonly modelPanels!: boolean;

  @Prop(Boolean) readonly disabledSubDegree!: boolean;

  @Prop({ default: true, type: Boolean }) readonly questionChecked!: boolean;

  @Prop(String) readonly questionDir!: string

  selectedBlankIndex = -1;

  created(): void {
    if (!this.simulation) {
      this.reCalculateTotalDegree();
    }
  }

  mounted() {
    const degreesRef = (this.$refs.degreesRef as HTMLElement[]);
    if (degreesRef && degreesRef.length > 0) {
      this.adjustDegreeAlignment();
      window.addEventListener('resize', this.adjustDegreeAlignment);
    }
    if (this.simulation) {
      setTimeout(() => {
        this.adjustTextFieldWidth();
      }, 0);
      window.addEventListener('resize', this.adjustTextFieldWidth);
    }
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.adjustDegreeAlignment);
    if (this.simulation) {
      window.removeEventListener('resize', this.adjustTextFieldWidth);
    }
  }

  highlightSelectedBlank(blankIndex: number): void {
    this.selectedBlankIndex = blankIndex;
  }

  resetSelectedIndex(): void {
    this.selectedBlankIndex = -1;
  }

  rules = {
    questionDegree: [
      (val: string) => !!val || this.$t('validations.required'),
      (val: number) => !(val < 0.01) || this.$t('validations.minValue', { min: 0.01 }),
      (val: number) => val <= 999 || this.$t('validations.maxValue', { max: 999 }),
      (val: string) => /^\d{0,3}(?:\.\d{1,2})?$/.test(val) || this.$t('validations.maxFloating'),
    ],
  };

  totalDegree = 0;

  fractionNumber = 2;

  answers: string[] = [];

  newText = this.questionText;

  getBlankQuestionText(text: string | undefined, answers: string[]) {
    if (text) {
      this.newText = Utils.replaceSpansWithAnswers(text, answers, this.questionDir);
      this.$nextTick(() => {
        this.renderEquations();
      });
    }
  }

  get questionWithAnswers(): string {
    this.getBlankQuestionText(this.questionText, this.answers);
    if (this.simulation) {
      this.newText = Utils.highlightSelectedBlank(this.newText, this.selectedBlankIndex);
    }
    return this.newText;
  }

  /* eslint-disable no-param-reassign */
  reCalculateTotalDegree() {
    let invalidGroupBlanks = 0;
    this.blanks.forEach((blank) => {
      blank.totalDegree = Number(
        this.calculateBlankTotalDegree(blank).toFixed(this.fractionNumber),
      );
      if (this.invalidBlankGroupDegrees(blank)) {
        invalidGroupBlanks += 1;
      }
    });
    this.totalDegree = Number(
      this.blanks
        .reduce((sum: number, blank: Blank) => sum + (blank.totalDegree || 0), 0)
        .toFixed(this.fractionNumber),
    );
    this.$emit('degreeChanged', {
      totalDegree: this.totalDegree,
      SpecIndex: this.SpecIndex,
      questionIndex: this.questionIndex,
      invalidGroupBlanks: Boolean(invalidGroupBlanks),
    });
  }
  /* eslint-disable no-param-reassign */

  calculateBlankTotalDegree(blank: Blank): number {
    return this.getGroupBlankHighestNDegrees(blank).reduce((sum, degree) => sum + Number(degree));
  }

  getGroupBlankHighestNDegrees(blank: Blank): number[] {
    return blank.answers
      .map((blankAnswer) => Number(blankAnswer.degree))
      .sort((a, b) => a - b)
      .slice(-1 * blank.blanksIndices.length);
  }

  invalidBlankGroupDegrees(blank: Blank): boolean {
    const arr = Array.from(new Set(this.getGroupBlankHighestNDegrees(blank)));
    return arr.length > 1;
  }

  toTitleCase(text: string | TranslateResult): string {
    return Utils.toTitleCase(text.toString());
  }

  getMaxDegree(blank: Blank): number {
    return Math.max(...blank.answers.map((blankAnswer) => blankAnswer.degree as number));
  }

  formatNumber(number: number | null): number {
    return number ? Utils.formatNumber(number, 2) : 0;
  }

  resetAnswers() {
    this.answers = [];
  }

  adjustDegreeAlignment(): void {
    (this.$refs.answersRef as HTMLElement[]).forEach((answer, index) => {
      const marginBottom = 4;
      this.$refs.degreesRef[index].style.height = `${answer.clientHeight - marginBottom}px`;
    });
  }

  adjustTextFieldWidth(): void {
    const textFields: NodeListOf<HTMLElement> = (this.$refs.container as HTMLElement).querySelectorAll('.v-input__control');
    textFields.forEach((textField: HTMLElement) => {
      const containerWidth = Number.parseInt(window.getComputedStyle(this.$refs.container as HTMLElement).width, 10)
        - Number.parseInt(window.getComputedStyle(this.$refs.container as HTMLElement).paddingLeft, 10)
        - Number.parseInt(window.getComputedStyle(this.$refs.container as HTMLElement).paddingRight, 10);
      const width = Math.min(containerWidth, 450);
      textField.style.maxWidth = `${width}px`;
    });
  }

  get allIndices(): number[] {
    const indicesArray: number[] = [];
    this.blanks.map((blank) => indicesArray.push(...blank.blanksIndices));
    return indicesArray.sort();
  }

  get systemDirection(): string {
    return this.$store.state.lang.lang === 'ar' ? 'right' : 'left';
  }
}
